import { render, staticRenderFns } from "./AnalysisToolsBackButton.vue?vue&type=template&id=4bb3635f&scoped=true"
import script from "./AnalysisToolsBackButton.vue?vue&type=script&lang=ts"
export * from "./AnalysisToolsBackButton.vue?vue&type=script&lang=ts"
import style0 from "./AnalysisToolsBackButton.vue?vue&type=style&index=0&id=4bb3635f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3635f",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/analysis-tools/analysis-tools-back-button.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fanalysis-tools%2FAnalysisToolsBackButton.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports